import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=663fa13d&scoped=true&lang=pug&"
import script from "./groups.vue?vue&type=script&lang=js&"
export * from "./groups.vue?vue&type=script&lang=js&"
import style0 from "./groups.vue?vue&type=style&index=0&id=663fa13d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fa13d",
  null
  
)

export default component.exports